module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av738-4855ca6323b99149f39a145ce6bb64f6.jpg";